import React from 'react';
import { useNavigate } from 'react-router-dom';
import { format, isSameDay, isSameMonth } from 'date-fns';
import { IMonthSlotProps } from '@pages/Schedule/components/Month/types';
import { Slot } from '@pages/Schedule/components/Slot';
import { useScheduleContext } from '@pages/Schedule/context/useScheduleContext';
import { formatTimeTo12Hour } from '@pages/Schedule/utils/getBlackoutsLocationForDate';
import { Routes } from '../../../../router';

export const MonthSlot = ({
  date,
  appointmentsAmount,
  blackoutsPhysician,
  blackoutLocation,
  eventTypes,
}: IMonthSlotProps) => {
  const schedule = useScheduleContext();

  const navigate = useNavigate();

  const selectedDate = schedule.selectedDate;

  const cellClassName = () => {
    if (!isSameMonth(date, selectedDate)) {
      return 'is-disabled';
    }
    if (isSameDay(date, selectedDate)) {
      return 'is-selected';
    }
    return '';
  };

  const onClick = () => {
    schedule.setDate(date);

    navigate(Routes.Day);
  };

  const slotDetails =
    !!appointmentsAmount &&
    `${appointmentsAmount}${'\u00A0'}appointment${appointmentsAmount > 1 ? 's' : ''}`;

  const formatTimeRangeBlackout = (blackoutime: {
    physicianName: string;
    from: string;
    from_time: string;
    to: string;
    to_time: string;
  }) => {
    const title = 'Sub-I coverage needed';

    return `${blackoutime.physicianName}: ${title} ${formatTimeTo12Hour(blackoutime.from_time)} - ${formatTimeTo12Hour(blackoutime.to_time)}`;
  };

  const formatTimeRange = (blackoutLocationTime: {
    from: string;
    from_time: string;
    to: string;
    to_time: string;
  }) => {
    const title = 'Location closed  - on-call coverage only';

    return `${title} ${blackoutLocationTime.from} ${blackoutLocationTime.from_time} - ${blackoutLocationTime.to} ${blackoutLocationTime.to_time}`;
  };

  return (
    <div className={`schedule-cell table-cell ${cellClassName()}`}>
      <span className="schedule-day">
        {isSameMonth(date, selectedDate) ? format(date, 'dd') : format(date, 'MMM dd')}
      </span>
      <div className="schedule-cell-content month">
        {!!appointmentsAmount && (
          <Slot
            variant="info"
            details={slotDetails}
            shortDetails={appointmentsAmount}
            eventTypes={eventTypes}
            handleClick={onClick}
          />
        )}
        {blackoutsPhysician &&
          blackoutsPhysician?.length > 0 &&
          blackoutsPhysician?.map((blackoutPhysician) => (
            <Slot
              key={blackoutPhysician.id}
              variant="blackout"
              details={formatTimeRangeBlackout(blackoutPhysician)}
              handleClick={onClick}
            />
          ))}
        {!!blackoutLocation && (
          <Slot
            variant="blackout-location"
            details={formatTimeRange(blackoutLocation)}
            handleClick={onClick}
          />
        )}
        {/* TODO uncomment if it'll be necessary to show empty days */}
        {/* {!appointmentsAmount && ( */}
        {/* <Slot variant="info" details="Free day" handleClick={onClick} /> */}
        {/* )} */}
      </div>
    </div>
  );
};
